import { TermConditionComponent } from './term-condition/term-condition.component';
import { FqaComponent } from './fqa/fqa.component';
import { CatcontrolComponent } from './catcontrol/catcontrol.component';
import { CommentcontrolComponent } from './commentcontrol/commentcontrol.component';
import { AdduserComponent } from './adduser/adduser.component';
import { EditgameComponent } from './editgame/editgame.component';
import { AddgameComponent } from './addgame/addgame.component';
import { HomeComponent } from './home/home.component';
import {Routes} from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthoService } from './Services/autho.service';
import { UsersComponent } from './users/users.component';
import { GamesComponent } from './games/games.component';
import { GamepageComponent } from './gamepage/gamepage.component';
import { ApproveComponent } from './approve/approve.component';
import { FeaturesComponent } from './features/features.component';
import { AddProductComponent } from './add-product/add-product.component';
import { BuildsComponent } from './builds/builds.component';

export const masterRoutes: Routes = [
    {path: ' ' , redirectTo: 'login'},
    {path: 'login', component: LoginComponent},
    {path: 'home', component: HomeComponent,canActivate:[AuthoService]},
    {path: 'users', component: UsersComponent,canActivate:[AuthoService]},
    {path: 'allgames/:id' , component: GamesComponent ,canActivate:[AuthoService] },
    {path: 'editgame/:id' , component:EditgameComponent,canActivate:[AuthoService]},
    {path: 'addUser', component: AdduserComponent,canActivate:[AuthoService]},
    {path: 'Features', component: FeaturesComponent,canActivate:[AuthoService]},
    {path: 'comment', component: CommentcontrolComponent ,canActivate:[AuthoService]},
    {path: 'Approve', component: ApproveComponent ,canActivate:[AuthoService]},
    {path: 'catControl', component: CatcontrolComponent,canActivate:[AuthoService]},
    {path: 'gamepage/:game_id/:user_id', component:GamepageComponent ,canActivate:[AuthoService] },
    {path: 'addgame', component: AddgameComponent , canActivate: [AuthoService] },
    {path: 'addproduct', component: AddProductComponent , canActivate: [AuthoService] },
    {path: 'builds', component: BuildsComponent , canActivate: [AuthoService] },
    {path: 'faq', component: FqaComponent , canActivate: [AuthoService] },
    {path: 'term-condition', component: TermConditionComponent , canActivate: [AuthoService] },
    {path: '**', redirectTo: 'login'}
];


// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/app.routes.ts